export default __webpack_public_path__ + "static/media/plombier-pro-600x400.c0b400ca.jpeg";